
  <section class="w3l-form-25">
    <div class="form-inner-cont">
      <div class="w3l-form-25">
          <h1>{{'Medical Records Data' | translate }}</h1>
          <h1 style="color: rgb(79, 79, 161);font-weight: bolder;">{{ 'Patient Documents' | translate }}</h1>
      </div>
    </div>

  <BR>
    <div id="w3l-appointment">
    <div  class="wrapper d-grid doctor-appointment">
      <form action="#" method="post" >
      <div class="appointment-form-field">
        <label style="width: 140px;">{{ 'Patient' | translate }}</label>
        <input type="text" name="pacode"  required="" style="width: 112px;" [(ngModel)]="patientcode" (change)="RertivePatient()" >
      <span class="fa fa-search" aria-hidden="true" style="cursor: grab;"  (click)="OpenEmployeeDialog()"></span>

      <label id="w3l-appointment" class="appointment-form-field" style="width: 600px;background-color:  rgb(187, 203, 238);border-style: solid;border-width: .5px;border-color: slategray;">{{patientname}}</label>
      </div>
    </form>
    </div>
  </div>
<BR>

  <div id="w3l-appointment">
    <div class="wrapper">
    <div class="d-grid doctor-appointment">
      <form action="#" method="post" >
        <table style="width: 900px;">

      <thead>
        <tr>

          <th class="grid-th" style="width: 5%;">{{'Doc.No. ' | translate }}</th>
          <th class="grid-th" style="width: 20%;">{{'Document Name' | translate }}</th>
          <th class="grid-th" style="width: 10%;">{{'Document Type' | translate }}</th>
          <th class="grid-th" style="width: 15%;">{{'Document Date' | translate }}</th>
          <th class="grid-th" style="width: 25%;">{{'Notes' | translate }}</th>
          <th class="grid-th" style="width: 20%;">{{'Image' | translate }}</th>

          <th class="grid-th" style="width: 7%;">{{'Select' | translate }}</th>

            </tr>
      </thead>
      <tbody>
        <tr class="grid-td-tr" style="height: 7px;align-content: center;" *ngFor="let sup of PatientDocumentsList; let i = index">
          <td class="grid-td-th" data-column="Item Line">{{sup.doccode}}</td>
          <td class="grid-td-th" data-column="Item ID">{{sup.docname}}</td>
          <td class="grid-td-th" data-column="Item ID">{{sup.doctype}}</td>
          <td class="grid-td-th" data-column="Item ID">{{sup.docdate}}</td>
          <td class="grid-td-th" data-column="Item ID">{{sup.docnotes}}</td>
          <td class="grid-td-th" data-column="Item ID">
          <a [href]="openDialogViwer(sup)" [download]="true" target="_blank">
            <img src = "{{sup.pathimage_1}}" alt="Item Image"   style="border: 1px;border-style: double;cursor: zoom-in;width: 170px; height: 100px;border-radius: 10%;"  />
          </a>
          </td>
          <td class="grid-td-th" data-column="Item Allocation">

            <button mat-raised-button  name="select" id="select" class="fa fa-pencil-square-o"  style="width:30px;background-color:#143d7b88;color: #fcfcfc; height: 30px; font-size: 85%;font-weight: bolder;" (click)="openDialogTransEditN(sup)" >{{'Select' | translate}}</button>

          </td>
        </tr>

      </tbody>
        </table>
        <button mat-raised-button style="width:30%;height: 50px; font-size: 85%; font-weight: bold;background-color: #143d7b;color: white;" (click)="DialogNewRecord()" >{{'Add New Record' | translate}}</button>
      </form>
    </div>
    </div>
  </div>




  <BR>
    <form class="example-button-container" style="width: 100%; text-align: center;" >
      <a href="medical-record"> <button mat-raised-button style="width:15%;background-color:#4abae7;color: #fffffe; height: 50px; font-size: 85%;font-weight: bolder;" (click)="Cloase_Dialog()">{{'Close' | translate}} </button></a>
    </form>

</section>






